module.exports = __webpack_public_path__ + "img/img-fachai-fish.6c7d2533.png";